/* eslint-disable */
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TimerIcon from '@material-ui/icons/Timer';
import format from 'date-fns/format';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import i18nLocaleSelector from '../../State/Store/I18n/Selectors/I18nLocale.selector';
import formatWithTime from '../../Support/DateTime/FormatWithTime/DateTimeFormatWithTime.support';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import OrderTimePropTypes from './OrderTime.component.props';
import orderTimeStyles from './OrderTime.component.styles';

/**
 * OrderTimeComponent
 * @export
 * @class OrderTimeComponent
 * @extends {React.Component<OrderTimeComponentComposedProps, OrderTimeComponentState>}
 */
export class OrderTimeComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<OrderTimeComponentProps>}
   * @memberof OrderTimeComponent
   */
  static defaultProps = {
    showDate: false,
  };

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`OrderTime`}
   * @memberof OrderTimeComponent
   */
  static displayName = `OrderTime`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof OrderTimeComponent
   */
  static propTypes = OrderTimePropTypes;

  /**
   * Data specific to the `<OrderTimeComponent />` instance
   * @type {OrderTimeComponentState}
   * @memberof OrderTimeComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<OrderTimeComponent />`
   * @memberof OrderTimeComponent
   */
  render() {
    const {
      classes,
      date,
      locale: { lang },
      showDate,
    } = this.props;
    if (!date) {
      return null;
    }
    const localeDateString = showDate ? `${format(date, `ddd D MMM`, { locale: lang })}, ` : null;
    const localeTimeString = formatWithTime(date, `h:mm A`, { locale: lang });
    return (
      <Grid alignItems="center" className={classes.timeContainer} container justify="flex-start">
        <Grid item>
          <TimerIcon fontSize="small" />
        </Grid>
        <Grid item className={classes.dateTimeLabel}>
          <Typography variant="overline">
            {localeDateString}
            {localeTimeString}
          </Typography>
        </Grid>
      </Grid>
    );
  }
}

/** @type {React.ComponentClass<OrderTimeComponentProps>} */
const OrderTime = compose(
  withStyles(themeCreateInjectableStyles(orderTimeStyles), { withTheme: true }),
  connect((state) => ({
    locale: i18nLocaleSelector(state),
  })),
)(OrderTimeComponent);

export default OrderTime;
